import { z } from "zod";

export const emailSchema = z
	.string()
	.trim()
	.toLowerCase()
	.pipe(z.email({ message: "Invalid email address" }));

export type EmailPayload = z.infer<typeof emailSchema>;
